import React from "react";
import { Loader2, ShieldCheck, ArrowRight } from "lucide-react";

/**
 * Below-video CTA strip — surfaces dynamically as the user watches.
 *
 * Post-2026-07-02 funnel restructure:
 *   - L.1..L.3: 20s before end → "Vai alla Lezione N+1" (plain nav, no paywall)
 *   - L.4: at 80% → "Richiedi informazioni per sbloccare il resto del corso"
 *     (opens the same dialog that used to live on L.1)
 */
export default function LessonBelowVideoCTAs({
  n, user, meta,
  l2InfoCtaVisible, endingSoonCtaVisible,
  upsellLoading, fireTrack, onUpsellClick,
}) {
  if (!l2InfoCtaVisible && !endingSoonCtaVisible) return null;

  return (
    <div className="mt-5 flex flex-col sm:flex-row gap-3 justify-center items-stretch" data-testid="below-video-ctas">
      {/* L.4 → richiedi info per sbloccare resto corso */}
      {n === 4 && l2InfoCtaVisible && (
        user?.l2_info_requested_at ? (
          <button
            type="button"
            disabled
            data-testid="below-video-l4-info-requested"
            className="cta-btn cta-btn--ghost-light opacity-70 cursor-default"
          >
            <ShieldCheck size={17} /> ✓ Richiesta inviata, ti contatteremo al più presto
          </button>
        ) : (
          <button
            type="button"
            data-testid="below-video-l4-info-btn"
            onClick={() => { fireTrack("below_cta_l4_info_click"); onUpsellClick(); }}
            className="cta-btn"
          >
            Richiedi informazioni per sbloccare il resto del corso <ArrowRight size={17} strokeWidth={2.4} />
          </button>
        )
      )}

      {/* L.1..L.3 → simple next-lesson navigation, no payment */}
      {n >= 1 && n <= 3 && endingSoonCtaVisible && meta.upsellKind === "next_lesson" && (
        <button
          type="button"
          data-testid="below-video-next-lesson-btn"
          disabled={upsellLoading}
          onClick={() => { fireTrack("below_cta_next_lesson_click"); onUpsellClick(); }}
          className="cta-btn disabled:opacity-70"
        >
          {upsellLoading
            ? <><Loader2 className="animate-spin" size={17} /> …</>
            : <>Vai alla Lezione {n + 1} <ArrowRight size={17} strokeWidth={2.4} /></>}
        </button>
      )}
    </div>
  );
}
